var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.832031,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFEEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8510_11841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4064 15.8478L23.4441 15.272L21.672 11.6816C20.9876 10.2947 19.0085 10.2951 18.3243 11.6815L16.5523 15.2719L12.59 15.8478C11.0594 16.0701 10.4484 17.9524 11.5555 19.0316L14.4227 21.8264L13.7459 25.7726C13.4844 27.297 15.0856 28.4597 16.4542 27.7404L19.9982 25.8771L23.5423 27.7404C24.909 28.4589 26.512 27.2968 26.2507 25.7726L25.5738 21.8264L28.441 19.0316C29.5483 17.952 28.9363 16.0701 27.4064 15.8478ZM27.324 17.8859L24.1557 20.9742C23.9672 21.158 23.8812 21.4228 23.9257 21.6823L24.6736 26.0432C24.7111 26.2622 24.4833 26.4275 24.2867 26.3243L20.3704 24.2654C20.1374 24.1429 19.8589 24.1429 19.6259 24.2654L15.7096 26.3243C15.513 26.4276 15.2852 26.2621 15.3227 26.0432L16.0707 21.6823C16.1152 21.4228 16.0291 21.158 15.8406 20.9742L12.6723 17.8859C12.5131 17.7308 12.6002 17.4631 12.8201 17.4311L17.1986 16.7948C17.4591 16.7569 17.6844 16.5934 17.8009 16.3572L19.7591 12.3896C19.8574 12.1905 20.139 12.1903 20.2373 12.3897L22.1955 16.3572C22.312 16.5934 22.5373 16.757 22.7978 16.7948L27.1763 17.4311C27.3961 17.4631 27.4831 17.7309 27.324 17.8859Z",
    fill: "#FF9649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.318 11.0423L13.3613 9.72542C13.1015 9.36805 12.6013 9.28873 12.2439 9.54852C11.8865 9.8082 11.8072 10.3085 12.0669 10.6659L13.0237 11.9827C13.2836 12.3403 13.7838 12.4193 14.1411 12.1596C14.4985 11.9 14.5778 11.3997 14.318 11.0423Z",
    fill: "#FF9649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1405 22.8433C11.0041 22.4232 10.5527 22.193 10.1325 22.3297L8.55297 22.843C8.13278 22.9795 7.90286 23.4308 8.03936 23.851C8.17609 24.2719 8.62816 24.501 9.04741 24.3646L10.6269 23.8514C11.0471 23.7148 11.2771 23.2635 11.1405 22.8433Z",
    fill: "#FF9649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7583 9.54855C27.4009 9.28886 26.9006 9.36803 26.6409 9.72546L25.6841 11.0423C25.4244 11.3997 25.5036 11.9 25.8611 12.1597C26.2186 12.4195 26.7189 12.34 26.9785 11.9828L27.9352 10.666C28.1949 10.3085 28.1157 9.80819 27.7583 9.54855Z",
    fill: "#FF9649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4452 22.843L29.8658 22.3297C29.4456 22.193 28.9943 22.4232 28.8577 22.8434C28.7212 23.2635 28.9511 23.7149 29.3713 23.8514L30.9508 24.3646C31.3701 24.501 31.8221 24.2719 31.9588 23.851C32.0954 23.4308 31.8654 22.9795 31.4452 22.843Z",
    fill: "#FF9649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0031 29.0448C19.5613 29.0448 19.2031 29.403 19.2031 29.8448V31.4684C19.2031 31.9102 19.5613 32.2684 20.0031 32.2684C20.4449 32.2684 20.803 31.9102 20.803 31.4684V29.8448C20.8031 29.4029 20.4449 29.0448 20.0031 29.0448Z",
    fill: "#FF9649"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8510_11841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.83203)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.232f38f66eb4176074e1200d23280f58.svg";
export { ForwardRef as ReactComponent };